module.exports = __webpack_public_path__ + "img/07-W.33cbc9bc.svg";